<template>
  <div v-if="!$store.state.navigation.loading.isActive" class="page-test">
    <div class="vm-dialog-overlay"></div>
    <div class="vm-header"
      :class="{ 'vm-extended-header': showSide }" 
      :style="linearGradient260px()">
      <Header
        :hasSide="hasSide"
        :mainNavTree="mainNavTree"
        :primaryColor="primaryColor"
        :secondaryColor="secondaryColor"
        :showSide="mobile"
        @burgerClick="showSide = !showSide"
      />
    </div>
    <div class="vm-container" :class="containerClasses">
      <div class="vm-side" :style="linearGradient">
        <Sidenav vm-user
          :tree="tree"
        />
      </div>
      <span class="vm-round"></span>
      <div class="vm-content" :style="{'padding-top': !itsMainPage() ? '64px' : '0'}">
        <div class="vm-overlay" @click.self="showSide = false"></div>
        <div class="vm-page">
          <router-view />
        </div>
      </div>
      <div class="vm-footer">
        <Footer v-if="!this.$store.state.navigation.site" />
      </div>
    </div>
  </div>
</template>

<script>
import Sidenav from './sidenav/Index';
import Header from './Header';
import Footer from './Footer';
import { theme } from '@app/theme';

export default {
  components: { Sidenav, Header, Footer },
  data: () => ({
    showSide: true,
    desktop: null,
    tree: [],
    triggerWidth: 1100,
    ...theme,
    mobile: false
  }),
  watch: {
    sideNavTree(tree) {
      if (!tree.length) {
        this.showSide = false;
      }
      this.init();
    },
    '$store.state.permission.resources': function(value) {
        this.setMainMenu();
    }
  },
  computed: {
    
    linearGradient() {
      return {
        background: this.primaryColor
        // `linear-gradient(45deg, ${this.primaryColor}, ${this.secondaryColor});`
      };
    },
    hasSide() {
      return this.$store.getters['navigation/hasSide'];
    },
    sideNavTree() {
      return this.$store.state.navigation.sideTree;
    },
    mainNavTree() {
      return this.$store.state.navigation.mainTree;
    },
    containerClasses() {
      return {
        'side-expanded': this.showSide,
        'side-collapse': !this.showSide,
        'side-push': true
      };
    }
  },
  created() {
   // this.$store.commit('navigation/hide');
    //this.$store.commit('navigation/setSite', window.location.host);
    this.setMainMenu();
    this.init();
    window.addEventListener('resize', this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
  methods: {
    linearGradient260px() {
      return {
        top: this.itsMainPage() ? '-64px' : '0',
        background: this.primaryColor
        //`linear-gradient(45deg, ${this.primaryColor} 260px, ${this.secondaryColor});`
      };
    },
    itsMainPage() {
      if (this.$store.state.navigation.site) {
        history.pushState('', document.title, window.location.pathname);
        const url = window.location.origin + '/';
        if (window.location.href === url) {
          return true;
        } else if (window.location.search) {
          return true;
        } else {
          return false;
        }
      } else {
          return false;
        }
    },
    init() {
      this.desktop = window.innerWidth > this.triggerWidth;
      if (this.desktop) {
        this.desktopTrigger();
      } else {
        this.mobileTrigger();
      }
    },
    resizeHandler({ target }) {
      const isDesktop = target.innerWidth > this.triggerWidth;
      if (isDesktop) {
        if (!this.desktop) {
          this.desktopTrigger();
        }
      } else if (this.desktop) {
        this.mobileTrigger();
      }
      this.desktop = isDesktop;
    },
    mobileTrigger() {
      this.showSide = false;
      this.mobile = true;
      const about = this.sideNavTree.length
        ? [
            {
              title: 'RADIUS-LAB',
              name: 'about-radius-lab',
              children: this.mainNavTree
            }
          ]
        : this.mainNavTree;
      this.tree = [...about, ...this.sideNavTree];
    },
    desktopTrigger() {
      this.showSide = !!this.sideNavTree.length;
      this.tree = this.sideNavTree;
      this.mobile = false;
    },
    setSaidMenu() {
      const payload = [
        {
          title: 'Основная информация',
          name: 'personal-area.main'
        },
        {
          title: 'Модули',
          name: 'personal-area.modules',
          children: [
            {
              title: 'Регистратура',
              name: 'personal-area.1',
              children: [
                {
                  title: 'Основная',
                  name: 'registry.main'
                },
                {
                  title: 'Департаменты',
                  name: 'registry.department'
                }
              ]
            },
            {
              title: 'Запись к врачу',
              name: 'personal-area.2'
            }
          ]
        },
        {
          title: 'Личная информация',
          name: 'personal-area.personal'
        }
      ];
      this.$store.commit('navigation/setSideTree', payload);
    },
    setMainMenu() {
      const payload = [
        {
          title: 'Главная',
          name: 'main'
        },
        {
          title: 'Модули',
          name: 'modules',
          children: [
            {
              title: 'Модуль видеосвязи',
              name: 'vuexchat'
            },
            {
              title: 'Конструктор форм',
              name: 'formbuilder.main'
            },
            {
              title: 'Справочники',
              name: 'dictionaries.index'
            }
          ]
        },
        {
          title: 'Запись',
          path: `clinic/${this.$store.state.clinic.organization.form.id}`,
          name: 'clinic.public',
          clinicName: this.$store.state.clinic.organization.form.id
        },
        !this.$store.state.navigation.site ? {
          title: 'Клиники',
          name: 'clinic.list'
        }: {
          title: 'Личный кабинет',
          path: `clinics/${this.$store.state.clinic.organization.form.id}/personal-area`,
          name: 'personal-area.main',
          clinicName: this.$store.state.clinic.organization.form.id
        },
        {
          title: 'Контакты',
          name: 'contacts'
        }
      ];
      if (this.$store.state.navigation.site) {
        if (this.$store.state.permission.resources && !this.$store.state.clinic.roles.includes(obj => {
          if (obj === 'orgadmin' || obj === 'doctor' || obj === 'employee') {
            return true;
          }
        })) {
        } else {
          payload.splice([payload.findIndex(obj => obj.title === 'Запись')], 1);
        }

      } else {
        payload.splice([payload.findIndex(obj => obj.title === 'Запись')], 1);
      }
      this.$store.commit('navigation/setMainTree', payload);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-test {
  overflow-x: hidden;
}
.vm-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  z-index: 12;
  transition: padding-left 300ms ease;
}
.vm-extended-header {
  padding-left: 260px;
}
.vm-side {
  z-index: 11;
  position: fixed;
  top: 64px;
  bottom: 0;
  left: 0;
  min-width: 260px;
  transition: left 300ms;
  overflow-y: auto;
}
.vm-content {
  position: relative;
  padding-top: 64px;
  padding-left: 260px;
  min-height: 100vh;
  transition: padding-left 300ms;
  display: flex;
  width: 100%;
}
.vm-content .vm-page {
  width: 100%;
}
.vm-overlay {
  display: none;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.35);
}
.vm-container.side-collapse .vm-side {
  left: -300px;
}
.vm-container.side-collapse .vm-content {
  padding-left: 0;
}
@media (max-width: 1508px) {
  .vm-extended-header {
    padding-left: 284px;
    padding-right: 24px;
  }
}
@media (max-width: 1270px) {
  .vm-extended-header >>> .vm-navbar-phone-button {
    display: none;
  }
}
@media (max-width: 1100px) {
  .vm-header {
    padding-left: 24px;
    padding-right: 24px;
  }
  .vm-container .vm-content {
    padding-left: 0;
  }
  .vm-container.side-expanded .vm-overlay {
    display: block;
  }
}
.vm-footer {
  background-color: #002244;
}
</style>
